var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFbMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99.01C4.362.01 0 4.133 0 9.7c0 2.913 1.194 5.43 3.138 7.169.163.146.261.35.269.568l.054 1.777a.8.8 0 0 0 1.122.708l1.982-.875a.798.798 0 0 1 .532-.04c.911.252 1.882.384 2.893.384 5.628 0 9.99-4.122 9.99-9.69S15.618.01 9.99.01z",
    fill: "url(#nqnegr8y6a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.992 12.535 6.927 7.88a1.5 1.5 0 0 1 2.166-.4l2.334 1.75a.6.6 0 0 0 .722-.002L15.3 6.837c.42-.32.97.184.687.63l-2.933 4.654a1.5 1.5 0 0 1-2.167.4l-2.333-1.75a.6.6 0 0 0-.722.001L4.68 13.166c-.42.32-.97-.185-.687-.631z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nqnegr8y6a",
    x1: 0,
    y1: 0.01,
    x2: 0,
    y2: 19.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFbMessenger);
export default __webpack_public_path__ + "static/media/ic-fb-messenger.981c586e7ba87b3a7998ccb068585197.svg";
export { ForwardRef as ReactComponent };